module.exports = __webpack_public_path__ + "fonts/Canaro-Book.1539468c.woff";